import React, { useState, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./user/context/AuthContext";
import { AppRoutes } from "./routes";
import { PublicRoutes } from "./publicRoutes/PublicRoutes";
import { SnackbarProvider } from "notistack";
import ZoomPage from './Components/ZoomPage'
import GoogleTranslate from './Components/GoogleTranslate'
import { HelmetProvider } from "react-helmet-async";

const App = () => {
  return (
    <>
      <HelmetProvider>
        {/* <GoogleTranslate /> */}
        <SnackbarProvider maxSnack={3}>
          <ZoomPage>
            <BrowserRouter>
              <AuthProvider>
                <MainLayout />
              </AuthProvider>
            </BrowserRouter>
          </ZoomPage >
        </SnackbarProvider>
      </HelmetProvider>
    </>
  );
};

const MainLayout = () => {
  return <LayoutWrapper />;
};

const LayoutWrapper = () => {
  const { isAuthenticated } = useAuth();
  console.log("LayoutWrapper==>", isAuthenticated())
  return isAuthenticated() ? <AppRoutes /> : <PublicRoutes />;
};

export default App;
